import React, { useEffect, useRef, useState } from "react";
import useOnScreen from '../../helpers/actions/isVisibleHook'
import Button from "../Button/button";
import style from './Modal.module.scss';

const Modal = (props) => {
    const clickRef = useRef(null);
    const wrapperRef = useRef(null);
    const insideRef = useRef(null);
    const [scrollable, setScrollable] = useState(false)
    const isVisible = useOnScreen(wrapperRef)
    const [scrollProps, setScrollProps] = useState({
        prevScrollPos: 0,
        visibility: false,
    })


    const handleScroll = () => {
        if (wrapperRef.current) {
            if (wrapperRef.current.offsetHeight < insideRef.current.clientHeight) {
                setScrollable(true)
            } else {
                setScrollable(false)
            }
        }
        if (wrapperRef.current) {
            const tmpPrevPos = scrollProps.prevScrollPos;
            const currentPos = wrapperRef.current.scrollTop;
            let tmpVisibility = scrollProps.visibility;
            if (tmpPrevPos < currentPos) {
                tmpVisibility = true;
            } else {
                tmpVisibility = false;
            }
            let tmpScrollProps = scrollProps;
            tmpScrollProps.visibility = tmpVisibility;
            tmpScrollProps.prevScrollPos = currentPos;
            setScrollProps({ ...tmpScrollProps });
        }
    }

    useEffect(() => {
        if (wrapperRef.current) {
            if (wrapperRef.current.offsetHeight < insideRef.current.clientHeight) {
                setScrollable(true)
            } else {
                setScrollable(false)
            }
        }
    }, []);

    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollTo(0, 0)
        }
    }, [props.value])

    useEffect(() => {
        if (isVisible) {
            document.body.classList.add(style.bodyClass);
        } else {
            document.body.classList.remove(style.bodyClass)
        }
    }, [isVisible])

    useEffect(() => {
        document.addEventListener("scroll", handleScroll, true);
        return () => {
            document.removeEventListener("scroll", handleScroll, true);
        };
    });
    return (
        <React.Fragment>
            <div className={style.ModalStyle}>
                <div
                    className={props.value ? style.modal : style.modalHide}
                    onClick={() => props.parentClose(props.tag)}
                >
                </div>
                <div className={props.value ? style.modalContent : style.modalContentHidden} ref={clickRef}>
                    <div className={scrollProps.visibility && scrollable ? style.ModalTitleScroll : style.ModalTitle}>
                        <h4 className={style.upperTitleText}>
                            {props.title}
                            {typeof props.tooltip != 'undefined' && props.tooltip != '' && <div className={style.tooltip}>
                                <div className={style.tooltipIcon}>h</div>
                                <p className={style.tooltipText}>{props.tooltip}</p>
                            </div>}
                        </h4>
                        <span onClick={() => props.parentClose(props.tag)} className={style.close}>
                            <span className={style.cancelModal}>e</span>
                        </span>
                    </div>
                    <div ref={wrapperRef} className={style.ModalContentInner}>
                        <div className={style.childWrapper} ref={insideRef}>
                            {props.children}
                        </div>
                    </div>
                    {props.editModalButtonsPack
                        ?
                        <div className={style.editModalButtonsPack}>
                            <div className={style.buttonsPack}>
                                <div className={style.rightSide}>
                                    <Button
                                        loading={props.calculateLoading}
                                        type="solid"
                                        label="محاسبه قیمت کالا"
                                        onclick={props.calculatePrice}
                                        tag="calcPrice"
                                    />
                                    <Button type="outline" label="انصراف" onclick={props.closeModal} tag="cancel" />
                                    {Object.keys(props.errors).length !== 0 ? <div className={style.errorWrapper}>
                                        <span>.لطفا فیلدهای مورد نیاز را پر کنید</span>
                                    </div> : null}
                                </div>
                                {props.showConfirmButton && <div className={style.leftSide}>
                                    <Button type="solid" label="تایید" onclick={props.sendDataToParent} tag="confirm" />
                                </div>}
                            </div>
                        </div>
                        :
                        <></>
                    }
                    <div
                        className={!scrollProps.visibility && scrollable ? style.modalFooterScroll : style.modalFooter}></div>
                </div>
            </div>
        </React.Fragment >
    )
}
export default Modal
/* value=true =======> showModal
   value=false  =======> hideModal
   title='' ==========> Modal title (REQUIRED)
   parentClose =======> closed via a button in props.children
*/